var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { ChevronDown } from '@shared/icons/icons';
import { CheckboxMenuBox, CheckboxMenuCheckboxWrapper, CheckboxMenuItemStyled, CheckboxMenuLabelWrapper, CheckboxMenuSpacerStyled, CheckboxMenuToggle, } from '@styled/CheckboxMenu';
import { ThreeStateCheckBox } from './CheckBox';
function calculatePosition(toggleRect, menuRect, height) {
    if (toggleRect === undefined || menuRect === undefined) {
        return {};
    }
    var style = {};
    // check vertical placement
    if (toggleRect.bottom + menuRect.height > document.documentElement.clientHeight) {
        // place menu above toggle
        style.bottom = document.documentElement.clientHeight - toggleRect.bottom + height;
    }
    else {
        // place menu under toggle
        style.top = toggleRect.bottom;
    }
    // check horizontal placement
    var horizontalMiddle = toggleRect.left + toggleRect.width / 2;
    if (horizontalMiddle + menuRect.width / 2 > document.documentElement.clientWidth) {
        // place as far right as possible
        style.right = 0;
    }
    else if (horizontalMiddle - menuRect.width / 2 < 0) {
        // place as far left as possible
        style.left = 0;
    }
    else {
        // place centered to toggle
        style.left = horizontalMiddle;
        style.transform = 'translateX(-50%)';
    }
    return style;
}
export default function CheckboxMenu(_a) {
    var title = _a.title, items = _a.items, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.active, active = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.showSelected, showSelected = _e === void 0 ? false : _e;
    var _f = __read(useState(false), 2), open = _f[0], setOpen = _f[1];
    var _g = __read(useState({}), 2), position = _g[0], setPosition = _g[1];
    var toggleRef = useRef(null);
    var menuBoxRef = useRef(null);
    var height = size === 'small' ? 24 : 32;
    useEffect(function () {
        // close on outside click
        var handleClick = function (e) {
            var _a, _b;
            if ((_a = menuBoxRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
                return;
            }
            if ((_b = toggleRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)) {
                return;
            }
            setOpen(false);
        };
        // add eventlistener to close element on outside click
        document.addEventListener('mousedown', handleClick);
        return function () {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [menuBoxRef, toggleRef]);
    useEffect(function () {
        var _a, _b;
        return setPosition(calculatePosition((_a = toggleRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), (_b = menuBoxRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect(), height));
    }, [open, height]);
    var checkboxMenuBox = (React.createElement(CheckboxMenuBox, { ref: menuBoxRef, style: open ? __assign({}, position) : { visibility: 'hidden', left: '-100%' } }, items.map(function (item, idx) {
        if ('spacer' in item) {
            return React.createElement(CheckboxMenuSpacerStyled, { key: "checkbox-menu-item-".concat(idx) });
        }
        else {
            return (React.createElement(CheckboxMenuItemStyled, { key: "checkbox-menu-item-".concat(idx), "$disabled": item.disabled },
                React.createElement(CheckboxMenuCheckboxWrapper, { onClick: function () { return (!item.disabled ? item.onToggle(!item.checked) : null); } },
                    React.createElement(ThreeStateCheckBox, { value: item.checked })),
                item.label && (React.createElement(CheckboxMenuLabelWrapper, { onClick: function () { return (!item.disabled ? item.onToggle(!item.checked) : null); } }, item.label)),
                item.afterButton && React.createElement(item.afterButton.icon, { onClick: item.afterButton.action })));
        }
    })));
    //@ts-ignore
    var toggleItems = items.filter(function (i) { return 'checked' in i; });
    var hasChecked = toggleItems.some(function (i) { return i.checked; });
    var selectedLabels = toggleItems.filter(function (i) { return i.label !== undefined && i.checked; }).map(function (i) { return i.label; });
    return (React.createElement("div", null,
        React.createElement(CheckboxMenuToggle, { ref: toggleRef, "$toggleHeight": height, "$active": active || open, "$disabled": disabled, "$iconOnly": title === undefined, onClick: disabled ? undefined : function () { return setOpen(!open); } },
            hasChecked && showSelected ? selectedLabels.join(', ') : title !== undefined && React.createElement(React.Fragment, null, title),
            React.createElement(ChevronDown, { height: height, width: height })),
        createPortal(checkboxMenuBox, document.getElementById('portal'))));
}
